import React from 'react';
import { ESSENTIAL, OPTIONAL } from './consentCatalogue';

/** The site's own always-on storage. */
export function EssentialTable() {
  return (
    <div className="ivori-consent-table-wrap">
      <table className="ivori-consent-table">
        <thead>
          <tr><th scope="col">Name</th><th scope="col">Kept in</th><th scope="col">What it is for</th><th scope="col">How long</th></tr>
        </thead>
        <tbody>
          {ESSENTIAL.map((row) => (
            <tr key={row.names.join('|')}>
              <td>{row.names.map((n) => <code key={n}>{n}</code>)}</td>
              <td>{row.where}</td>
              <td>{row.purpose}</td>
              <td>{row.duration}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/** The providers and cookies behind one optional purpose (analytics, recording or advertising). */
export function ProviderTables({ category }) {
  const cat = OPTIONAL.find((c) => c.id === category);
  if (!cat) return null;
  return (
    <>
      {cat.providers.map((p) => (
        <div className="ivori-consent-provider" key={p.name}>
          <h4>{p.name}</h4>
          <p className="ivori-consent-muted">{p.detail}</p>
          <div className="ivori-consent-table-wrap">
            <table className="ivori-consent-table">
              <thead>
                <tr><th scope="col">Cookie or storage</th><th scope="col">Set by</th><th scope="col">How long</th></tr>
              </thead>
              <tbody>
                {p.items.map((i) => (
                  <tr key={i.name}>
                    <td><code>{i.name}</code></td>
                    <td>{i.party}</td>
                    <td>{i.duration}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {p.policyUrls.length > 0 && (
            <p>
              {p.policyUrls.map((u, idx) => (
                <React.Fragment key={u.href}>
                  {idx > 0 ? ' · ' : ''}
                  <a href={u.href} target="_blank" rel="noopener noreferrer">{u.label}</a>
                </React.Fragment>
              ))}
            </p>
          )}
        </div>
      ))}
    </>
  );
}
